import React, { useCallback, useState, useEffect, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
import BigNumber from 'bignumber.js'
import { Text } from 'rebass'

// components
import Modal, { ModalProps } from '../../../components/bakery/Modal'
// import ModalActions from '../../../components/bakery/ModalActions'
// import ModalTitle from '../../../components/bakery/ModalTitle'
import BakePriceInput from '../../../components/restaurant/BakePriceInput'
import { ButtonNewConfirmed } from '../../../components/Button'
import Loader from '../../../components/Loader'
import { AutoRow } from '../../../components/Row'

import { AuctionBake } from '../../../constants/artwork'
// import { SUPPORTTYPE } from '../../../constants/bakery/nft'

// hooks
import { useActiveWeb3React } from '../../../hooks'
import { useAddPopup } from '../../../state/application/hooks'
import { userTokenDecimals } from '../../../userType/userTokenDecimals'

const InputWrapper = styled.div`
  width: 360px;
  margin: 24px auto 12px;
`
const Button = styled(ButtonNewConfirmed)<{disabled?: boolean}>`
  margin: 32px auto 0;
  width: 145px;
  height: 32px;
  font-size: 14px;
  border-radius: 26px;
`

interface SellComboModalProps extends ModalProps {
  onConfirm: (amount: string, tokenName?: string) => any
  tokenName?: string
  min?: string
  title: string
  type?: string
  onAuction?: (amount: string, tokenName?: string) => any
  marketType?: string
  nftPrice?: string
}

const SellComboModal: React.FC<SellComboModalProps> = ({
  onDismiss,
  onConfirm,
  tokenName = '',
  min,
  title,
  type = '',
  onAuction,
  marketType,
  nftPrice
}) => {
  const theme = useContext(ThemeContext)
  const [price, setPrice] = useState('')
  const [curTokenName, setCurTokenName] = useState(tokenName)
  const [decimals, setDecimals] = useState(18)
  const [pendingTx, setPendingTx] = useState(false)

  useEffect(() => {
    const tokenDecimals = userTokenDecimals(curTokenName)
    setDecimals(tokenDecimals)
  }, [curTokenName])

  const onUserInput = (val: string) => {
    if (title === 'Please set the opening price') {
      const text: string = val.replace(/^0+/g, '').replace(/[^\d]/g, '')
      setPrice(text)
    } else {
      setPrice(val)
    }
  }
  const onChangeTokenName = (val: string) => {
    setCurTokenName(val)
  }
  const onSelectMin = () => {
    setPrice(min ? min : '0')
  }

  const { library } = useActiveWeb3React()
  const addPopup = useAddPopup()

  const orderSell = useCallback(async () => {
    try {
      setPendingTx(true)
      const realPrice = new BigNumber(price)
        .multipliedBy(
          new BigNumber(10).pow(decimals)
        ).toString()
      let auctionHash: any
      let txHash: any
      if (type === 'Auction' && onAuction) {
        auctionHash = await onAuction(price)
        txHash = auctionHash && await onConfirm(new BigNumber(AuctionBake + '')
        .multipliedBy(
          new BigNumber(10).pow(decimals)
        ).toString(),curTokenName)
      } else {
        txHash = await onConfirm(realPrice, curTokenName)
      }

      if (!txHash) {
        setPendingTx(false)
        onDismiss && onDismiss()
      } else {
        // Seccussful
        if (!library) return
        const closeModal = () => {
          setPendingTx(false)
          onDismiss && onDismiss()
        }
        library
          .getTransactionReceipt(txHash.transactionHash)
          .then(receipt => {
            if (receipt) {
              addPopup(
                {
                  txn: {
                    hash: txHash.transactionHash,
                    success: receipt.status === 1,
                    summary: 'Sold NFT on NFT Marketplace!'
                  }
                },
                txHash.transactionHash
              )
            }
            closeModal()
          })
          .catch(error => {
            setPendingTx(false)
            closeModal()
            console.error(`failed to check transaction hash: ${txHash.transactionHash}`, error)
          })
      }
    } catch (e) {
      setPendingTx(false)
      console.log(e)
    }
  }, [price, onConfirm, onDismiss, library, addPopup, onAuction, type, decimals, curTokenName])

  return (
    <Modal maxWidth={424} padding="32px 32px 24px">
      {/* <ModalTitle text={title} /> */}
      <Text color={theme.bsText28} fontFamily="Roboto-Bold" fontSize="20px" textAlign="center">{title}</Text>
      <InputWrapper>
        <BakePriceInput
          value={price}
          onChange={onUserInput}
          onChangeToken={onChangeTokenName}
          symbol={tokenName}
          min={min}
          marketType={marketType}
          onSelectMin={onSelectMin}
        />
      </InputWrapper>
      {/* <Text color={theme.bsText35} fontFamily="Roboto-Regular" fontSize="14px">Purchase Price: { nftPrice + ' ' + tokenName }</Text> */}
      {/* <ModalActions>
        <ButtonConfirmed
          fontSize={14}
          height={40}
          padding="0px 18px"
          onClick={onDismiss}
        >Cancel</ButtonConfirmed>
        <Button
          disabled={pendingTx || !(min ? new BigNumber(price).gte(min) : new BigNumber(price).gt(0)) }
          onClick={orderSell}
        >
          {pendingTx ? (
            <AutoRow gap="6px" justify="center">
              Pending <Loader stroke="white" />
            </AutoRow>
          ) : 'Confirm'}
        </Button>
      </ModalActions> */}
      <Button
        disabled={pendingTx || !(min ? new BigNumber(price).gte(min) : new BigNumber(price).gt(0)) }
        altDisabledStyle={pendingTx || !(min ? new BigNumber(price).gte(min) : new BigNumber(price).gt(0)) }
        onClick={orderSell}
      >
        {pendingTx ? (
          <AutoRow gap="6px" justify="center">
            Pending <Loader stroke="white" />
          </AutoRow>
        ) : 'Confirm'}
      </Button>
    </Modal>
  )
}

export default SellComboModal
